"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.default = void 0;
var _inheritsLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/inheritsLoose"));
var _react = _interopRequireWildcard(require("react"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
var globalId = 0;
var MaskedImage = /*#__PURE__*/function (_Component) {
  (0, _inheritsLoose2.default)(MaskedImage, _Component);
  function MaskedImage() {
    var _this;
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _Component.call.apply(_Component, [this].concat(args)) || this;
    _this.id = "mask-" + (globalId += 1);
    return _this;
  }
  var _proto = MaskedImage.prototype;
  _proto.render = function render() {
    return /*#__PURE__*/_react.default.createElement("svg", {
      className: this.props.className,
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 100 100",
      preserveAspectRatio: "none"
    }, /*#__PURE__*/_react.default.createElement("defs", null, /*#__PURE__*/_react.default.createElement("mask", {
      id: this.id
    }, /*#__PURE__*/_react.default.createElement("image", {
      width: "100",
      height: "100",
      xlinkHref: this.props.mask,
      preserveAspectRatio: "none"
    }))), /*#__PURE__*/_react.default.createElement("image", {
      width: "100",
      height: "100",
      mask: this.id,
      xlinkHref: this.props.image,
      preserveAspectRatio: "none"
    }));
  };
  return MaskedImage;
}(_react.Component);
MaskedImage.defaultProps = {
  className: undefined
};
var _default = exports.default = MaskedImage;